import { render, staticRenderFns } from "./Vote2.vue?vue&type=template&id=393024fd&scoped=true"
import script from "./Vote2.vue?vue&type=script&lang=js"
export * from "./Vote2.vue?vue&type=script&lang=js"
import style0 from "./Vote2.vue?vue&type=style&index=0&id=393024fd&prod&lang=css"
import style1 from "./Vote2.vue?vue&type=style&index=1&id=393024fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393024fd",
  null
  
)

export default component.exports